module.exports = __webpack_public_path__ + "img/Panna_s.a75b54fa.jpg";